
let recentlySwiper = null;
let collectionSwiper = null;

function debounce(fn, delay) {
  let timeout;
  return (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => fn(...args), delay);
  };
}

function renderRecentlyViewed() {
  const container = document.querySelector(".recently-viewed-container-la");
  if (!container) return;

  let recentlyViewed = JSON.parse(localStorage.getItem("recentlyViewed")) || [];

  container.innerHTML = recentlyViewed.map(item => `
    <div class="recently-viewed-item-la swiper-slide">
      <a href="${item.url}" class="slider-link-la">
        <img src="${item.image}" class="recently-viewed-item-image-la">
        <p class="slider-title-la">${item.title}</p>
        <p class="price-global">${item.price}</p>
      </a>
    </div>
  `).join("");
}

function getCartSectionId() {
  return document.getElementById("main-cart-footer")?.dataset.id || null;
}

function getShopifyRoot() {
  return window.Shopify?.routes?.root || "/";
}

function getCartApiUrl(path) {
  return `${getShopifyRoot()}cart/${path}.js`;
}

function destroyCartSwipers() {
  if (recentlySwiper) {
    recentlySwiper.destroy(true, true);
    recentlySwiper = null;
  }

  if (collectionSwiper) {
    collectionSwiper.destroy(true, true);
    collectionSwiper = null;
  }
}

function replaceCartSectionMarkup(sectionMarkup) {
  if (!sectionMarkup) return false;

  const parser = new DOMParser();
  const doc = parser.parseFromString(sectionMarkup, "text/html");
  const newSection = doc.querySelector(".cart-items-whole-la");
  const oldSection = document.querySelector(".cart-items-whole-la");

  if (!newSection || !oldSection) return false;

  destroyCartSwipers();
  oldSection.innerHTML = newSection.innerHTML;
  return true;
}

function replaceCartDrawerMarkup(sectionMarkup) {
  if (!sectionMarkup) return false;

  const parser = new DOMParser();
  const doc = parser.parseFromString(sectionMarkup, "text/html");
  const newDrawer = doc.querySelector(".cart-drawer-la");
  const oldDrawer = document.querySelector(".cart-drawer-la");

  if (!newDrawer || !oldDrawer) return false;

  const wasOpen = oldDrawer.classList.contains("cart-drawer-active-la");

  oldDrawer.replaceWith(newDrawer);

  if (wasOpen) {
    newDrawer.classList.add("cart-drawer-active-la");
    document.body.style.overflow = "hidden";
  }

  return true;
}

function finalizeCartRender() {
  setTimeout(() => {
    reinitCartControls();
    renderRecentlyViewed();
    initSwipers();
    initSliderTabs();
    bindDiscountCode();
    loadSavedDiscount();
  }, 50);
}

function fetchAndReplaceCartSection(sectionId) {
  if (!sectionId) return Promise.resolve();

  return fetch(window.location.pathname + "?section_id=" + sectionId)
    .then(res => res.text())
    .then(html => {
      replaceCartSectionMarkup(html);
      finalizeCartRender();
    });
}

function fetchAndReplaceCartDrawer() {
  if (!document.querySelector(".cart-drawer-la")) return Promise.resolve();

  return fetch("/?section_id=cart-drawer-la")
    .then(res => res.text())
    .then(html => {
      replaceCartDrawerMarkup(html);
    })
    .catch(error => {
      console.error("Cart drawer sync error:", error);
    });
}

function renderCartFromState(state) {
  updateCartCounts(state);

  const sectionId = getCartSectionId();
  const renderedSection = sectionId && state.sections ? state.sections[sectionId] : null;

  if (renderedSection && replaceCartSectionMarkup(renderedSection)) {
    finalizeCartRender();
    return fetchAndReplaceCartDrawer().then(() => state);
  }

  return Promise.all([
    fetchAndReplaceCartSection(sectionId),
    fetchAndReplaceCartDrawer()
  ]).then(() => state);
}

window.renderCartFromState = renderCartFromState;

function hasActiveDiscountState(state) {
  const hasCartLevelDiscount =
    Array.isArray(state?.cart_level_discount_applications) && state.cart_level_discount_applications.length > 0;
  const hasLineLevelDiscount =
    Array.isArray(state?.items) &&
    state.items.some(item => Array.isArray(item.line_level_discount_allocations) && item.line_level_discount_allocations.length > 0);
  const hasAppliedDiscountCode =
    Array.isArray(state?.discount_codes) && state.discount_codes.some(code => code.applicable !== false);

  return hasCartLevelDiscount || hasLineLevelDiscount || hasAppliedDiscountCode;
}

function setDiscountError(message = "") {
  const error = document.getElementById("discount-code-error");
  const errorText = document.querySelector(".cart-discount-error-text-la");
  const input = document.getElementById("discount-code-input");

  if (!error || !errorText || !input) return;

  if (message) {
    errorText.textContent = message;
    error.hidden = false;
    input.setAttribute("aria-invalid", "true");
    return;
  }

  errorText.textContent = "";
  error.hidden = true;
  input.removeAttribute("aria-invalid");
}

function updateCartDiscount(code) {
  const sectionId = getCartSectionId();
  if (!sectionId) return Promise.resolve(null);

  return fetch(getCartApiUrl("update"), {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      discount: code,
      sections: [sectionId],
      sections_url: window.location.pathname,
    }),
  })
    .then(async res => {
      const responseText = await res.text();

      if (!res.ok) {
        throw new Error(responseText || `Discount request failed with status ${res.status}`);
      }

      try {
        return JSON.parse(responseText);
      } catch (error) {
        throw new Error("Discount response was not valid JSON.");
      }
    });
}

function bindDiscountCode() {
  const btn = document.getElementById("apply-discount-btn");
  const input = document.getElementById("discount-code-input");
  const removeBtn = document.querySelector("[data-remove-discount]");

  if (btn && input) {
    const submitDiscount = () => {
      const code = input.value.trim();
      setDiscountError();

      if (!code) {
        setDiscountError("Please enter a promo code.");
        return;
      }

      btn.disabled = true;
      localStorage.setItem("discount_code", code);

      updateCartDiscount(code)
        .then(state => {
          if (!hasActiveDiscountState(state)) {
            setDiscountError("Please enter a valid promo code.");
            return;
          }

          localStorage.removeItem("discount_code");
          return renderCartFromState(state);
        })
        .catch(err => {
          console.error("Discount error:", err);
          setDiscountError("Something went wrong while applying the promo code.");
        })
        .finally(() => {
          btn.disabled = false;
        });
    };

    btn.addEventListener("click", submitDiscount);
    input.addEventListener("input", () => {
      setDiscountError();
    });
    input.addEventListener("keydown", event => {
      if (event.key === "Enter") {
        event.preventDefault();
        submitDiscount();
      }
    });
  }

  if (removeBtn) {
    removeBtn.addEventListener("click", () => {
      localStorage.removeItem("discount_code");
      removeBtn.disabled = true;

      updateCartDiscount("")
        .then(state => renderCartFromState(state))
        .catch(err => {
          console.error("Discount remove error:", err);
          alert("Something went wrong while removing the promo code.");
        })
        .finally(() => {
          removeBtn.disabled = false;
        });
    });
  }
}

function loadSavedDiscount() {
  const input = document.getElementById("discount-code-input");
  const saved = localStorage.getItem("discount_code");
  if (input && saved) input.value = saved;
  if (!input) localStorage.removeItem("discount_code");
}

function initSliderTabs() {
  const sliderWithTitle = document.querySelector(".one_slider_title_global-la");
  const sliderWithContainer = document.querySelector(".one-swiper-global-slider-la");
  const sliderAlsoContainer = document.querySelector(".two-swiper-global-slider-la");
  const sliderAlsoTitle = document.querySelector(".two_slider_title_global-la");

  if (!sliderWithTitle || !sliderWithContainer) return;

  sliderWithTitle.classList.add("active-title");
  sliderWithContainer.classList.add("active-container");

  function activateSlider(activeTitle, activeContainer, inactiveTitle, inactiveContainer) {
    inactiveTitle.classList.remove("active-title");
    inactiveContainer.classList.remove("active-container");
    activeTitle.classList.add("active-title");
    activeContainer.classList.add("active-container");
  }

  if (sliderAlsoTitle && sliderAlsoContainer) {
    sliderWithTitle.addEventListener("click", () => {
      activateSlider(
        sliderWithTitle,
        sliderWithContainer,
        sliderAlsoTitle,
        sliderAlsoContainer
      );
    });

    sliderAlsoTitle.addEventListener("click", () => {
      activateSlider(
        sliderAlsoTitle,
        sliderAlsoContainer,
        sliderWithTitle,
        sliderWithContainer
      );
    });
  }
}

function initSwipers() {
  const recentlyEl = document.querySelector(".recently-viewed-wrapper-la");
  const collectionEl = document.querySelector(".cart-collections-slider-container-la");

  destroyCartSwipers();

  if (recentlyEl && recentlyEl.querySelector(".swiper-wrapper")?.children.length) {
    recentlySwiper = new Swiper(recentlyEl, {
      slidesPerView: "auto",
      spaceBetween: 8,
      observer: true,
      observeParents: true,
      navigation: {
        nextEl: ".swiper-button-next-cart-recently-la",
        prevEl: ".swiper-button-prev-cart-recently-la",
      },
      pagination: {
        el: ".swiper-page-recently-la",
        clickable: true
      },
    });
  }

  if (collectionEl && collectionEl.querySelector(".swiper-wrapper")?.children.length) {
    collectionSwiper = new Swiper(collectionEl, {
      slidesPerView: "auto",
      spaceBetween: 8,
      observer: true,
      observeParents: true,
      navigation: {
        nextEl: ".swiper-button-next-also-la",
        prevEl: ".swiper-button-prev-also-la",
      },
        pagination: {
        el: ".swiper-page-recently-la",
        clickable: true

      },
    });
  }
}

function updateCartCounts(data) {
  const count = data.item_count;

  const header = document.querySelector(".cart-count-header-la");
  if (header) header.textContent = count > 0 ? count : "";

  const bubble = document.querySelector(".cart-count-bubble-la");
  if (bubble) bubble.classList.toggle("product-form-active-la", count > 0);

  const pageCount = document.querySelector(".cart-items-count-totle");
  if (pageCount) pageCount.textContent = `(${count})`;

  const cartWrapper = document.querySelector(".cart-items-whole-la");
  if (cartWrapper) cartWrapper.classList.toggle("is-empty-cart", count === 0);
}

function setAccordionState(item, expanded) {
  if (!item) return;

  const button = item.querySelector('.view-informetion-la');
  const content = item.querySelector('.information-dropdown-la');

  item.classList.toggle('active-accordions-la', expanded);

  if (button) {
    button.setAttribute('aria-expanded', String(expanded));
  }

  if (content) {
    content.hidden = !expanded;
  }
}

function bindViewInformation() {
  const container = document.querySelector('.information-cart-items-la');
  if (!container) return;

  const items = container.querySelectorAll('.items-block-information-la');
  if (!items.length) return;

  items.forEach(item => {
    const button = item.querySelector('.view-informetion-la');
    const content = item.querySelector('.information-dropdown-la');
    if (!button || !content) return;

    const isExpanded = item.classList.contains('active-accordions-la');
    button.setAttribute('aria-expanded', String(isExpanded));
    content.hidden = !isExpanded;

    button.addEventListener('click', () => {
      const shouldExpand = button.getAttribute('aria-expanded') !== 'true';

      items.forEach(otherItem => setAccordionState(otherItem, false));

      if (shouldExpand) {
        setAccordionState(item, true);
      }
    });
  });
}

function updateCartItem(variantId, quantity) {
  const sectionId = getCartSectionId();

  fetch(getCartApiUrl("change"), {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      id: variantId,
      quantity,
      sections: sectionId ? [sectionId] : [],
      sections_url: window.location.pathname,
    }),
  })
    .then(async res => {
      const responseText = await res.text();

      if (!res.ok) {
        throw new Error(responseText || `Cart request failed with status ${res.status}`);
      }

      return JSON.parse(responseText);
    })
    .then(data => {
      renderCartFromState(data);
    })
    .catch(err => console.error("Cart error:", err));
}

function setCartMinusButtonState(wrapper) {
  if (!wrapper) return;

  const input = wrapper.querySelector(".cart-items-qty-input");
  const minusButton = wrapper.querySelector(".cart-items-qty-minus");
  if (!input || !minusButton) return;

  const quantity = parseInt(input.value, 10) || 0;
  const shouldDisable = quantity <= 1;

  minusButton.disabled = shouldDisable;
  minusButton.setAttribute("aria-disabled", String(shouldDisable));
}

function syncCartMinusButtons() {
  document.querySelectorAll(".cart-items-container-la").forEach(wrapper => {
    setCartMinusButtonState(wrapper);
  });
}

function bindCartButtons() {
  document.querySelectorAll(".cart-items-qty-plus").forEach(btn => {
    btn.addEventListener("click", () => {
      const wrapper = btn.closest(".cart-items-container-la");
      const input = wrapper.querySelector(".cart-items-qty-input");
      const id = wrapper.querySelector(".remove-items-button-la").dataset.removeItems;
      updateCartItem(id, (parseInt(input.value, 10) || 0) + 1);
    });
  });

  document.querySelectorAll(".cart-items-qty-minus").forEach(btn => {
    btn.addEventListener("click", () => {
      const wrapper = btn.closest(".cart-items-container-la");
      const input = wrapper.querySelector(".cart-items-qty-input");
      const id = wrapper.querySelector(".remove-items-button-la").dataset.removeItems;
      const currentQuantity = parseInt(input.value, 10) || 1;

      if (currentQuantity <= 1) {
        setCartMinusButtonState(wrapper);
        return;
      }

      updateCartItem(id, currentQuantity - 1);
    });
  });

  document.querySelectorAll(".remove-items-button-la").forEach(btn => {
    btn.addEventListener("click", e => {
      e.preventDefault();
      updateCartItem(btn.dataset.removeItems, 0);
    });
  });

  syncCartMinusButtons();
}

function reinitCartControls() {
  document.querySelectorAll(".cart-items-qty-plus, .cart-items-qty-minus, .remove-items-button-la")
    .forEach(el => el.replaceWith(el.cloneNode(true)));

  bindCartButtons();
  bindViewInformation();
}

bindCartButtons();
bindViewInformation();
bindDiscountCode();
loadSavedDiscount();
renderRecentlyViewed();

setTimeout(() => {
  initSwipers();
  initSliderTabs();
}, 100);


if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class extends HTMLElement {
      constructor() {
        super();
        this.addEventListener('change', debounce(event => {
          const body = JSON.stringify({ note: event.target.value });
          fetch(`${routes.cart_update_url}`, { method: "POST", body });
        }, 300));
      }
    }
  );
}
